import { Api } from "./Api";

export default {
    index() {
        return Api.get(`/v1/management/clients`);
    },
    show(client_id) {
        return Api.get(`/v1/management/clients/${client_id}`);
    },
    update(client_id, obj) {
        return Api.put(`/v1/management/clients/${client_id}`, obj);
    },
}